<template>
  <div class="container--get-started">
    <FeedbackHeader :title="$t('get_started')" />
    <div class="container__inner">
        <div class="question-container">
            <img class="logo--ths-small" src="/images/marque-logo-small.svg" />
            <h4 class="heading-second--grey">Thanks for sharing how you’re feeling. The questions that follow are relevant for all of us and are a way of checking in with each other. Your responses will be confidential.</h4>
        </div>
      <router-link :to="{ name: 'feedback'}" class="button-ths button-ths--link">{{ $t('next') }}</router-link>
    </div>
  </div>
</template>

<script>
    import FeedbackHeader from '@/components/FeedbackHeader.vue'
    
    export default {
        components: {FeedbackHeader},
        data() {
            return {
                title: '',
            }
        }
    };
</script>
